import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import default_en from './translations/default_en.json';
import bbc_en from './translations/bbc_en.json';
import { LanguageCode, LocalizationDictionary, LocalizationNamespace } from './types';

export const defaultNS = 'default' as const;

export const resources = {
  en: {
    default: default_en,
    bbc: bbc_en
  }
} as const satisfies Record<LanguageCode, Partial<Record<LocalizationNamespace, Partial<LocalizationDictionary>>>>;

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  resources
});

export default i18n;
